import { registerLocaleData } from '@angular/common';
import { Injectable } from '@angular/core';
import { registerLocale } from 'i18n-iso-countries';

import {
  getAngularLocale,
  getDateFnsLocale,
} from '~/core/helpers/locale/locale.helper';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  // can be used by date fns formater that needs a Locale
  public dateLocale;

  /**
   *  import i18n-iso-countries lang
   */
  private static async importCountries(): Promise<void> {
    const bg = await import('i18n-iso-countries/langs/bg.json');
    const de = await import('i18n-iso-countries/langs/de.json');
    const en = await import('i18n-iso-countries/langs/en.json');
    const es = await import('i18n-iso-countries/langs/es.json');
    const fr = await import('i18n-iso-countries/langs/fr.json');
    const id = await import('i18n-iso-countries/langs/id.json');
    const it = await import('i18n-iso-countries/langs/it.json');
    const pt = await import('i18n-iso-countries/langs/pt.json');
    const th = await import('i18n-iso-countries/langs/th.json');
    registerLocale(bg);
    registerLocale(de);
    registerLocale(en);
    registerLocale(es);
    registerLocale(fr);
    registerLocale(id);
    registerLocale(it);
    registerLocale(pt);
    registerLocale(th);
  }

  /**
   * import date-fns locale
   */
  private async importDateLang(locale: string): Promise<void> {
    /* locales should also be imported through the webpack.config.ts */
    const module = await import(
      `date-fns/locale/${getDateFnsLocale(locale)}/index.js`
    );
    this.dateLocale = module.default;
    return this.dateLocale;
  }

  /**
   * import angular locale
   */
  private async importLocale(locale: string): Promise<void> {
    const module = await import(
      `/node_modules/@angular/common/locales/${getAngularLocale(locale)}.mjs`
    );
    return registerLocaleData(module.default);
  }

  /**
   * load i18n deps
   */
  public async importLang(lang: string): Promise<void> {
    LocaleService.importCountries();

    await this.importDateLang(lang);
    return await this.importLocale(lang);
  }
}
